import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';
import { Fonts } from '../../../utils/resources/fonts';
import { Colors } from '../../../utils/resources/colors';


export interface DateTimePickerCSSStyle extends UIComponentCSSStyle
{
    getLabelCSSStyle(): object;
    getInputWrapperCSSStyle(isRequired:boolean, disabled:boolean):object;
    getInputItemCSSStyle(disabled:boolean): object;
    getErrorMsgCSSStyle(): object;
}

export class DateTimePickerCSSStyleImpl extends UIComponentCSSStyleImpl implements DateTimePickerCSSStyle{
    
    getWrapperCSSStyle(): object{
        return {
                    position: 'relative', 
                    width: '100%'
                };
    }

    getLabelCSSStyle(): object{
        return {
                position: 'relative', 
                height: '15px', 
                lineHeight: '15px', 
                paddingBottom: '5px', 
                fontFamily:this.getResources().getFontFamily(), 
                fontWeight: 600,
                fontSize: this.getResources().getFont(Fonts.h7),
                color: this.getResources().getColor(Colors.color_17)
            };    
    }

    getInputWrapperCSSStyle(isRequired:boolean, disabled:boolean): object {
        return {
            position: 'relative', 
            width: "100%", 
            // height: '23px', 
          
            outline:'none',
            border: 'none',
                };
    }

    getInputItemCSSStyle(disabled:boolean): object{
        return { 
                    position: 'relative', 
                    height: '19px', 
                    lineHeight: '19px', 
                    width: '100%',
                    top: disabled?'-7px':'-1px',
                    boxSizing: 'border-box', 
                    marginTop:"4px",
                    paddingBottom: '3px', 
                    paddingLeft: disabled?'0px':'10px', 
                    borderRadius: '3px', 
                    border:'none',
                    outline:'none',
                    color: this.getResources().getColor(Colors.color_7),
                    backgroundColor: this.getResources().getColor(Colors.color_5),
                    fontSize:this.getResources().getFont(Fonts.h6),
                    fontFamily:this.getResources().getFontFamily()
                };
    }

    getErrorMsgCSSStyle(): object {
        return {
                    marginTop: '2px', 
                    color: this.getResources().getColor(Colors.color_17), 
                    width: '100%', 
                    fontSize: this.getResources().getFont(Fonts.h8), 
                    fontWeight: 600,
                    fontFamily:this.getResources().getFontFamily()
                };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/datetimepicker/datetimepickercss.tsx